import { SvgIcon } from '../../../../common/components/SvgIcon';
import { useSgwtTranslation } from '../../../../common/i18n';
import { useBotConversation } from '../../shared/BotConversationContext';

export const UserInteractionContactUsFeedback = () => {
  const { translate } = useSgwtTranslation();
  const { feedbackContactUs } = useBotConversation();

  const continueConversation = () => feedbackContactUs(false);
  const contactSupport = () => feedbackContactUs(true);

  return (
    <section className="sgwt-chatbot-message sgwt-chatbot-interaction mb-3 p-12px d-flex flex-between-x align-items-start gap-3">
      <div>
        <div className="mb-2">{translate('contact-us.feedback')}</div>
        <button type="button" className="btn btn-primary" onClick={contactSupport}>
          {translate('contact-us.button')}
        </button>
      </div>
      <button type="button" className="btn btn-flat-secondary btn-icon" onClick={continueConversation}>
        <SvgIcon type="close" />
      </button>
    </section>
  );
};
